import * as React from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import styled from 'styled-components';
import { Card } from '@99designs/brief';
import { Box, Heading } from '@99designs/emu';
import { mediaQuery } from '@99designs/emu/css';
import { spaces } from '@99designs/emu/settings';
import { IconEdit1 } from '@99designs/icons';

const CardInner = styled.div`
    max-width: 650px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;

    ${mediaQuery.between('small', 'medium')} {
        margin-bottom: ${spaces['1.5bu']};
        padding-left: ${spaces['2bu']};
        padding-right: ${spaces['2bu']};
    }
`;

interface Props {
    heading: string;
    onEditClick?: () => void;
    url: string;
    children: React.ReactNode;
}

class SummaryCard extends React.Component<Props> {
    render() {
        const { heading, onEditClick, children } = this.props;

        return (
            <Card variations={['summary']}>
                <Box color={'grey800'} paddingTop="4bu" paddingBottom="2bu">
                    <CardInner>
                        <Heading accessibilityLevel={3} data-testid={'SummaryCardHeader'}>
                            {heading}
                        </Heading>
                        <ReactRouterLink
                            onClick={onEditClick}
                            className={'icon-button'}
                            to={this.props.url}
                        >
                            <IconEdit1 fontSize={24} />
                        </ReactRouterLink>
                    </CardInner>
                </Box>
                <Card.Block>
                    <div className="card-summary-list" data-testid="card-summary-list">
                        {children}
                    </div>
                </Card.Block>
            </Card>
        );
    }
}

export default SummaryCard;
